import * as Tgcc from '../tgccGlobal'
import * as React from 'react'
import Radium, { StyleRoot } from 'radium'
import {CSSProperties} from 'react'
import {connect} from 'react-redux'



class CatProps extends Tgcc.BaseProps {
    text: string;
    selected: boolean;
    onChange?: (filter: string) => void;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    width: '150px',
    margin: '2px 8px',
    overflow: 'hidden',
    cursor: 'pointer',
    height: '24px',
    lineHeight: '22px',
    '@media (max-width:375px)': {
        width:'190px'
    }
};

const catStyle: CSSProperties = {
    fontFamily:'CenturyGothic',
    fontSize: '13px',
    letterSpacing: '1px',
    fontWeight: "bold",
    whiteSpace: 'nowrap',
    textAlign: 'left',
    padding: '1px 5px',
    textTransform: 'none',
    backgroundColor: 'transparent'
};

let catStyleSelect = Object.assign({}, catStyle, {backgroundColor: Tgcc.Styles.grayHighlight});

export class _DesignCategory extends React.Component<CatProps, any> {
    
    state = {
        selected: false 
    }

    changeFilter = (category: string) => {
        if(this.props.onChange)
            this.props.onChange(category)
    } 

    render() {
        var cStyle = this.props.selected ? catStyleSelect : catStyle;
        
        return (
            <div style={wrapperStyle}>
                <div style={cStyle} onClick={this.doFilter}>{this.props.text}</div>
            </div>
        )
    }


    doFilter = () => {
        // clear the existing filter if it matches
        if(this.props.selected)
            this.changeFilter(null);
        else 
            this.changeFilter(this.props.text)
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    if(state && state.FilterDesignsByCategory)
        return { selected: ownState.text.toString().toUpperCase() == state.FilterDesignsByCategory.toString().toUpperCase() };
    return {selected: false};
};
export var DesignCategory = connect(mapStateToProps)(Radium(_DesignCategory));

